import { Layers, ListChecks, Brain, User } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const ValueProposition = () => {
  const features = [
    {
      icon: Layers,
      title: "Unified Workspace",
      description: "Run CRM, tasks, invoices, finance, and goals from a single, modern SaaS dashboard. No more jumping between five different tools to understand your day."
    },
    {
      icon: ListChecks,
      title: "Super Queue (Unified Inbox)",
      description: "See your most impactful actions across sales, tasks, invoices, clients, and goals in one ranked list — prioritized by revenue, urgency, and risk."
    },
    {
      icon: Brain,
      title: "AI Business Partner",
      description: "Let your AI co-founder surface next-best actions, write smart daily summaries, and keep you on track to your monthly revenue and goal targets."
    },
    {
      icon: User,
      title: "Built for Solo Freelancers",
      description: "No team complexity. No enterprise bloat. Catlyo is opinionated and optimized for one person: you."
    }
  ];

  return (
    <section className="py-20 bg-muted/50">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            The operating system for your freelance life.
          </h2>
          <p className="text-xl text-muted-foreground">
            Everything your freelance business needs — finally in one place.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card key={index} className="border-border/50 hover:border-primary/50 transition-colors">
                <CardHeader>
                  <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                    <Icon className="h-6 w-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl">{feature.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
